import { tryCatchHelper } from '../../../../helpers';
import {
  ACTIVO_ENTHOR_BLOQUES,
  ALL_ENTHOR_BLOQUES,
  LOADING_ALL_ENTHOR_BLOQUES,
} from './EntHorBloquesReducer';
import {
  allEntHorBloquesService,
  deleteEntHorBloquesService,
  oneEntHorBloquesService,
  saveEntHorBloquesService,
} from './EntHorBloquesService';

export const allEntHorBloquesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENTHOR_BLOQUES, payload: true });
    const res = await allEntHorBloquesService(params);
    dispatch({ type: ALL_ENTHOR_BLOQUES, payload: res.data });
    dispatch({ type: LOADING_ALL_ENTHOR_BLOQUES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENTHOR_BLOQUES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntHorBloquesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntHorBloquesService(id, data);
    notify(res.data.message);
    await allEntHorBloquesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntHorBloquesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENTHOR_BLOQUES, payload: data });
};

export const oneEntHorBloquesAction = async (dispatch, id) => {
  try {
    const res = await oneEntHorBloquesService(id);
    await setActivoEntHorBloquesAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntHorBloquesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntHorBloquesService(id);
    notify(res.data.message);
    await setActivoEntHorBloquesAction(dispatch, null);
    await allEntHorBloquesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
